import { render } from "./index.vue?vue&type=template&id=1e772648&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1e772648&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e772648"],['__file',"src/vab/layouts/VabLayoutCommon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e772648"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e772648', __exports__)) {
    api.reload('1e772648', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1e772648&scoped=true", () => {
    api.rerender('1e772648', render)
  })

}


export default __exports__